export default __webpack_public_path__ + "static/caseStudy3-fr-f5bbfdc08b6bdd45a5a5d6587e5c4e87.webp";